<template>
  <div v-loading="loading">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="queryParams" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <div class="mb-2">
        <el-alert show-icon title="以下产品可能存在防伪追溯的风险" type="warning" :closable="false">
        </el-alert>
      </div>
      <el-table  :height="heightStyleObj" :data="listData" style="width: 100%" highlight-current-row border stripe>
        <template slot="empty">
          <el-empty description="暂无数据"></el-empty>
        </template>
        <el-table-column prop="completeCode" label="产品UDI码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lastScanTime" label="最近一次扫码时间" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.lastScanTime ? parseTime(scope.row.lastScanTime) : null }}
          </template>
        </el-table-column>
        <el-table-column prop="handleStatus" label="异常类型" width="120">
          <template slot-scope="scope">
            {{ `${scope.row.scannum}人扫描` }}
          </template>
        </el-table-column>
        <el-table-column prop="created" label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handlePreview(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination v-show="queryParams.total > 0" class="flex justify-end" :total="queryParams.total"
        :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
    </el-card>
    <Detail v-if="detailVisible" :visible="detailVisible"  :security-info="securityInfo" @close="close"/>
  </div>
</template>

<script>
import { getSecurityList } from '@/api/security/index'
import Detail from './components/detail'

export default {
  components: { Detail },
  data() {
    return {
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          placeholder: '产品名称/UDI码',
          width: '300px',
          type: 'input'
        },
        {
          label: '扫码时间',
          field: 'dateTime',
          type: 'date'
        },
      ],
      queryParams: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        searchValue: null,
        dateTime: []
      },
      listData: [],
      securityInfo:{},
      loading: false,
      detailVisible:false,
      heightStyleObj:null
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getList()
  },
  methods: {
    reset() {
      this.queryParams = Object.assign(this.$data.queryParams, this.$options.data.call(this)).queryParams
      this.search()
    },
    search() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    getList() {
      const queryParams = JSON.parse(JSON.stringify(this.queryParams))
      if (queryParams.dateTime) {
        const [scanTimeBegin, scanTimeEnd] = queryParams.dateTime
        queryParams.scanTimeBegin = scanTimeBegin
        queryParams.scanTimeEnd = scanTimeEnd
        delete queryParams.dateTime
      }
      this.loading = true
      getSecurityList(queryParams).then((res) => {
        this.listData = res.rows
        this.queryParams.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    // 查看
    handlePreview(row) {
      this.securityInfo = JSON.parse(JSON.stringify(row))
      this.detailVisible = true
    },
    // 关闭弹窗
    close() {
      this.detailVisible = false
      this.securityInfo = {}
      this.getList()
    }
  }
}
</script>
